//////////////////////////////////////////////////////
/// DO NOT EDIT                                    ///
/// Generated by Trygghetsfonden.Dataverse.Tools   ///
/// Source file: xrm.context.include.txt           ///
//////////////////////////////////////////////////////

export enum tsl_projektdeltagande_tsl_statusanstalld {
	Nyperson = 1,
	Tilldelningvgledning = 2,
	FrdjupadVgledning = 3,
	Internvgledning = 6,
	Avbokadavdeltagare = 7,
	Avslutadvgledninggenomfrd = 8,
	Avbruten = 11,
	Avslutadejgttattn = 12,
};
